// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Data Center page styling (scoped with the dcp- prefix).
   Same visual language as Insights / Dashboard / Enquiries: gradient hero,
   rounded cards, accent-tinted icon tiles. Accent colors come from the app-wide
   tokens (.accent-blue/violet/teal/green in App.css), so every tinted element
   works in both themes from one definition. All text keeps a 6:1 contrast
   ratio and is never smaller than 12px.
   The modals render outside the page container, so they carry their own
   .dcp-modal-dark class instead of relying on .dark-theme.
   ========================================================================== */

:root {
  --dcp-muted: #475569;
  --dcp-line: rgba(148, 163, 184, 0.32);
  --dcp-field-bg: #ffffff;
  --dcp-field-border: #8a97a8;
  --dcp-field-text: #111827;
}
.dark-theme.dcp-page,
.dcp-modal-dark {
  --dcp-muted: rgba(255, 255, 255, 0.72);
  --dcp-line: rgba(255, 255, 255, 0.13);
  --dcp-field-bg: #2a2f34;
  --dcp-field-border: rgba(255, 255, 255, 0.28);
  --dcp-field-text: #f1f5f9;
}

/* ---------- motion ---------- */
/* slide only: fading text in makes it momentarily fail contrast checks */
@keyframes dcp-fade-up {
  from { transform: translateY(10px); }
  to   { transform: none; }
}
@keyframes dcp-shimmer {
  0%   { background-position: 100% 0; }
  100% { background-position: 0 0; }
}
@keyframes dcp-toast-in {
  from { transform: translateY(14px); }
  to   { transform: none; }
}
.dcp-fade { animation: dcp-fade-up 0.45s ease both; animation-delay: var(--d, 0ms); }

@media (prefers-reduced-motion: reduce) {
  .dcp-fade, .dcp-skel, .dcp-toast { animation: none !important; }
  .dcp-card, .dcp-nav-item, .dcp-icon-btn, .dcp-btn { transition: none !important; }
}

/* ---------- hero ---------- */
.dcp-hero {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin: 8px 0 20px;
  padding: 26px 30px;
  border-radius: 22px;
  color: #fff;
  background: linear-gradient(120deg, #1a3483 0%, #2d52c4 55%, #6d3fae 100%);
  box-shadow: 0 18px 40px rgba(26, 52, 131, 0.28);
}
.dark-theme .dcp-hero {
  background: linear-gradient(120deg, #13224f 0%, #1f3a8a 55%, #4c2a85 100%);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
}
.dcp-hero::before,
.dcp-hero::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.dcp-hero::before {
  width: 260px; height: 260px;
  right: -60px; top: -110px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.22), transparent 70%);
}
.dcp-hero::after {
  width: 200px; height: 200px;
  right: 22%; bottom: -120px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.14), transparent 70%);
}
.dcp-hero-text, .dcp-hero-stats { position: relative; z-index: 1; }

.dcp-hero-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  background: rgba(6, 14, 40, 0.34);
  border: 1px solid rgba(255, 255, 255, 0.28);
}
.dcp-hero-title {
  margin: 10px 0 4px;
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.4px;
  color: #fff;
}
.dcp-hero-sub { margin: 0; max-width: 620px; color: #ffffff; font-size: 14.5px; }

.dcp-hero-stats { display: flex; flex-wrap: wrap; gap: 8px; }
.dcp-hero-stat {
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: rgba(6, 14, 40, 0.38);
}
.dcp-hero-stat b { font-weight: 850; margin-right: 3px; }

/* ---------- layout ---------- */
.dcp-layout {
  display: grid;
  grid-template-columns: 300px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}
.dcp-main { min-width: 0; }

.dcp-card {
  border: 1px solid transparent;
  border-radius: 18px;
  background: #ffffff;
  color: #111827;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07);
}
.dark-theme .dcp-card {
  background: #212529;
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
}

/* ---------- section nav ---------- */
.dcp-nav { padding: 10px; }
.dcp-nav-list { display: flex; flex-direction: column; gap: 4px; }

.dcp-nav-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 12px;
  border: 1px solid transparent;
  border-radius: 14px;
  background: transparent;
  text-align: left;
  color: #111827;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.dark-theme .dcp-nav-item { color: #ffffff; }
.dcp-nav-item:hover { background: rgba(15, 23, 42, 0.05); }
.dark-theme .dcp-nav-item:hover { background: rgba(255, 255, 255, 0.07); }
.dcp-nav-item:focus-visible { outline: 3px solid rgba(45, 82, 196, 0.45); outline-offset: 2px; }

.dcp-nav-item.active {
  background: var(--tmis-accent-tint, #eef2ff);
  border-color: color-mix(in srgb, var(--tmis-accent, #1a3483) 35%, transparent);
}
.dark-theme .dcp-nav-item.active {
  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);
  border-color: color-mix(in srgb, var(--tmis-accent-dark) 45%, transparent);
}

.dcp-nav-icon,
.dcp-panel-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  font-size: 19px;
  background: var(--tmis-accent-tint, #eef2ff);
  color: var(--tmis-accent, #1a3483);
}
.dark-theme .dcp-nav-icon,
.dark-theme .dcp-panel-icon {
  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);
  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
}
.dcp-nav-item.active .dcp-nav-icon { background: var(--tmis-accent, #1a3483); color: #ffffff; }
.dark-theme .dcp-nav-item.active .dcp-nav-icon {
  background: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
  color: #0b1220;
}

.dcp-nav-text { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }
.dcp-nav-label { font-size: 14.5px; font-weight: 800; line-height: 1.25; }

.dcp-nav-count {
  min-width: 26px;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  background: #e8ecf2;
  color: #1e293b;
}
.dark-theme .dcp-nav-count { background: rgba(255, 255, 255, 0.12); color: #ffffff; }
.dcp-nav-item.active .dcp-nav-count { background: var(--tmis-accent, #1a3483); color: #ffffff; }
.dark-theme .dcp-nav-item.active .dcp-nav-count { background: var(--tmis-accent-dark-text, var(--tmis-accent-dark)); color: #0b1220; }

/* ---------- panel ---------- */
.dcp-panel { padding: 22px 24px 24px; }
.dcp-panel-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}
.dcp-panel-icon { width: 46px; height: 46px; font-size: 23px; border-radius: 14px; }
.dcp-panel-titles { flex: 1 1; min-width: 220px; }
.dcp-panel-title { margin: 0; font-size: 21px; font-weight: 800; letter-spacing: -0.2px; }
.dcp-panel-sub { margin: 2px 0 0; font-size: 13.5px; color: var(--dcp-muted); }
.dcp-panel-actions { display: flex; flex-wrap: wrap; gap: 8px; }

/* ---------- buttons ---------- */
.dcp-page .dcp-btn.btn,
.dcp-modal-dark .dcp-btn.btn,
.modal .dcp-btn.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 9px 18px;
  font-size: 14px;
  font-weight: 700;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}
.dcp-btn.btn:hover:not(:disabled) { transform: translateY(-1px); }
.dcp-btn.btn:focus-visible { outline: 3px solid rgba(45, 82, 196, 0.45); outline-offset: 2px; }
.dcp-btn.dcp-btn-sm { padding: 6px 14px; font-size: 13px; }

.dcp-btn.dcp-btn-primary.btn {
  color: #ffffff;
  background: linear-gradient(120deg, #1a3483, #2457b8);
  box-shadow: 0 8px 18px rgba(26, 52, 131, 0.28);
}
.dark-theme .dcp-btn.dcp-btn-primary.btn,
.dcp-modal-dark .dcp-btn.dcp-btn-primary.btn {
  background: linear-gradient(120deg, #2457b8, #5a43d0);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.4);
}
.dcp-btn.dcp-btn-primary.btn:hover:not(:disabled) { color: #ffffff; }

.dcp-btn.dcp-btn-outline.btn {
  color: #1e293b;
  background: #ffffff;
  border-color: #8a97a8;
}
.dark-theme .dcp-btn.dcp-btn-outline.btn {
  color: #f1f5f9;
  background: transparent;
  border-color: rgba(255, 255, 255, 0.4);
}
.dcp-btn.dcp-btn-outline.btn:hover:not(:disabled) { color: #0f172a; background: #eef2f7; }
.dark-theme .dcp-btn.dcp-btn-outline.btn:hover:not(:disabled) { color: #ffffff; background: rgba(255, 255, 255, 0.1); }

.dcp-btn.dcp-btn-ghost.btn { color: #1e293b; background: #e8ecf2; }
.dcp-modal-dark .dcp-btn.dcp-btn-ghost.btn { color: #f1f5f9; background: #343a40; }
.dcp-btn.dcp-btn-ghost.btn:hover:not(:disabled) { color: #0f172a; background: #d9dfe8; }
.dcp-modal-dark .dcp-btn.dcp-btn-ghost.btn:hover:not(:disabled) { color: #ffffff; background: #444b52; }

.dcp-btn.dcp-btn-danger.btn { color: #ffffff; background: #b02a37; }
.dcp-btn.dcp-btn-danger.btn:hover:not(:disabled) { color: #ffffff; background: #8a1f2b; }

/* ---------- toolbar / search ---------- */
.dcp-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin: 20px 0 14px;
}
.dcp-search {
  position: relative;
  flex: 1 1 280px;
  max-width: 440px;
}
.dcp-search-icon {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 19px;
  color: var(--dcp-muted);
  pointer-events: none;
}
.dcp-search-input {
  width: 100%;
  height: 42px;
  padding: 0 38px 0 40px;
  font-size: 14px;
  border-radius: 999px;
  border: 1px solid var(--dcp-field-border);
  background: var(--dcp-field-bg);
  color: var(--dcp-field-text);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.dcp-search-input:focus {
  outline: 0;
  border-color: #2457b8;
  box-shadow: 0 0 0 3px rgba(45, 82, 196, 0.25);
}
.dcp-search-input::-webkit-search-cancel-button { display: none; }
.dcp-search-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--dcp-muted);
  font-size: 17px;
}
.dcp-search-clear:hover { background: rgba(148, 163, 184, 0.25); }

.dcp-count {
  margin-left: auto;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 700;
  background: var(--tmis-accent-tint, #eef2ff);
  color: var(--tmis-accent, #1a3483);
}
.dark-theme .dcp-count {
  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);
  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
}

/* ---------- table ---------- */
.dcp-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--dcp-line);
  border-radius: 14px;
  transition: filter 0.2s ease;
}
.dcp-table-wrap.is-refreshing { filter: saturate(0.6); }
.dcp-table { width: 100%; border-collapse: collapse; font-size: 14px; }
.dcp-table th {
  padding: 11px 14px;
  text-align: left;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--dcp-muted);
  background: rgba(148, 163, 184, 0.14);
  border-bottom: 1px solid var(--dcp-line);
}
.dcp-table td {
  padding: 12px 14px;
  vertical-align: middle;
  border-bottom: 1px solid var(--dcp-line);
}
.dcp-table tbody tr:last-child td { border-bottom: 0; }
.dcp-table tbody tr { transition: background 0.12s ease; }
.dcp-table tbody tr:hover { background: rgba(26, 52, 131, 0.05); }
.dark-theme .dcp-table tbody tr:hover { background: rgba(255, 255, 255, 0.05); }

.dcp-col-no { width: 64px; }
.dcp-col-color { width: 170px; }
.dcp-col-date { width: 130px; }
.dcp-col-actions { width: 120px; text-align: center !important; }
.dcp-cell-no, .dcp-cell-date { color: var(--dcp-muted); white-space: nowrap; }
.dcp-cell-desc { max-width: 380px; overflow-wrap: anywhere; }
.dcp-name { font-weight: 800; }
.dcp-table td:nth-child(2) { min-width: 150px; }
.dcp-cell-desc { min-width: 180px; }

.dcp-pill {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.4;
  overflow-wrap: break-word;
}

.dcp-color { display: inline-flex; align-items: center; gap: 8px; }
.dcp-color code {
  padding: 0;
  font-size: 12.5px;
  font-weight: 600;
  color: inherit;
  background: none;
}
.dcp-color-dot {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 1px solid rgba(15, 23, 42, 0.25);
}
.dark-theme .dcp-color-dot { border-color: rgba(255, 255, 255, 0.35); }

.dcp-row-actions { display: flex; justify-content: center; gap: 6px; }
.dcp-icon-btn {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid var(--dcp-line);
  background: transparent;
  color: #1e293b;
  font-size: 18px;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.dark-theme .dcp-icon-btn { color: #f1f5f9; }
.dcp-icon-btn:hover { background: #e6ebf8; color: #1a3483; border-color: #8aa0dd; }
.dark-theme .dcp-icon-btn:hover { background: rgba(157, 195, 244, 0.16); color: #cfe2fb; border-color: #9dc3f4; }
.dcp-icon-btn.danger:hover { background: #fee2e2; color: #a11616; border-color: #e58f8f; }
.dark-theme .dcp-icon-btn.danger:hover { background: rgba(248, 113, 113, 0.16); color: #fcc4c4; border-color: #f87171; }
.dcp-icon-btn:focus-visible { outline: 3px solid rgba(45, 82, 196, 0.45); outline-offset: 2px; }

/* ---------- loading / empty / states ---------- */
.dcp-skeletons { display: flex; flex-direction: column; gap: 10px; }
.dcp-skel {
  display: block;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(90deg, rgba(148, 163, 184, 0.16), rgba(148, 163, 184, 0.34), rgba(148, 163, 184, 0.16));
  background-size: 200% 100%;
  animation: dcp-shimmer 1.3s ease infinite;
}

.dcp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 42px 16px;
  text-align: center;
  border: 1px dashed var(--dcp-line);
  border-radius: 14px;
}
.dcp-empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 4px;
  border-radius: 18px;
  font-size: 28px;
  background: var(--tmis-accent-tint, #eef2ff);
  color: var(--tmis-accent, #1a3483);
}
.dark-theme .dcp-empty-icon {
  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);
  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
}
.dcp-empty-title { font-size: 16px; font-weight: 800; }
.dcp-empty-sub { margin-bottom: 8px; font-size: 14px; color: var(--dcp-muted); }

.dcp-state {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
  padding: 16px 18px;
  border-radius: 14px;
  font-size: 14px;
  background: rgba(148, 163, 184, 0.14);
}
.dcp-state-inline { margin-top: 12px; padding: 10px 14px; }
.dcp-state-error { background: #fee2e2; color: #7f1212; }
.dark-theme .dcp-state-error { background: rgba(248, 113, 113, 0.14); color: #fcc4c4; }

.dcp-inline-error {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  background: #fee2e2;
  color: #7f1212;
}
.dark-theme .dcp-inline-error,
.dcp-modal-dark .dcp-inline-error { background: rgba(248, 113, 113, 0.14); color: #fcc4c4; }

/* ---------- privacy ---------- */
.dcp-privacy {
  margin-top: 22px;
  padding: 20px 22px;
  border-radius: 16px;
  background: #e2f6ea;
  border: 1px solid rgba(10, 95, 52, 0.28);
}
.dcp-privacy.is-off { background: #fef3c7; border-color: rgba(130, 63, 9, 0.35); }
.dark-theme .dcp-privacy {
  background: color-mix(in srgb, #4ade80 10%, transparent);
  border-color: rgba(94, 227, 143, 0.35);
}
.dark-theme .dcp-privacy.is-off {
  background: color-mix(in srgb, #fbbf24 10%, transparent);
  border-color: rgba(251, 191, 36, 0.4);
}

.dcp-privacy-top { display: flex; align-items: center; flex-wrap: wrap; gap: 14px; }
.dcp-privacy-shield {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  font-size: 25px;
  background: #0a5f34;
  color: #ffffff;
}
.dcp-privacy.is-off .dcp-privacy-shield { background: #823f09; }
.dark-theme .dcp-privacy-shield { background: #4ade80; color: #06210f; }
.dark-theme .dcp-privacy.is-off .dcp-privacy-shield { background: #fbbf24; color: #2b1700; }

.dcp-privacy-text { flex: 0 1 auto; display: flex; flex-direction: column; align-items: flex-start; gap: 4px; }
.dcp-privacy-title { font-size: 18px; font-weight: 800; }

.dcp-status {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 800;
}
.dcp-status.ok { background: #0a5f34; color: #ffffff; }
.dcp-status.warn { background: #823f09; color: #ffffff; }
.dark-theme .dcp-status.ok { background: #4ade80; color: #06210f; }
.dark-theme .dcp-status.warn { background: #fbbf24; color: #2b1700; }

.dcp-privacy-list {
  list-style: none;
  margin: 18px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.dcp-privacy-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14.5px;
  line-height: 1.5;
}
.dcp-privacy-list li svg { flex-shrink: 0; margin-top: 3px; font-size: 18px; color: #0a5f34; }
.dcp-privacy.is-off .dcp-privacy-list li svg { color: #823f09; }
.dark-theme .dcp-privacy-list li svg { color: #5ee38f; }
.dark-theme .dcp-privacy.is-off .dcp-privacy-list li svg { color: #fbc53d; }

/* ---------- modals ---------- */
.dcp-modal-dark .modal-content {
  background: #212529;
  color: #f1f5f9;
  border: 1px solid rgba(255, 255, 255, 0.12);
}
.modal .modal-content { border-radius: 18px; }
.dcp-modal-head { border-bottom-color: var(--dcp-line); }
.dcp-modal-foot { border-top-color: var(--dcp-line); gap: 8px; }
.dcp-modal-dark .dcp-modal-head,
.dcp-modal-dark .dcp-modal-foot { border-color: rgba(255, 255, 255, 0.13); }
.dcp-modal-dark .btn-close { filter: invert(1) grayscale(100%) brightness(200%); }
.dcp-modal-title { font-size: 19px; font-weight: 800; }
.dcp-modal-body .form-label { font-size: 13.5px; font-weight: 700; }

.dcp-modal-body .form-control.dcp-input {
  border-radius: 12px;
  border: 1px solid var(--dcp-field-border);
  background-color: var(--dcp-field-bg);
  color: var(--dcp-field-text);
}
.dcp-modal-body .form-control.dcp-input:focus {
  border-color: #2457b8;
  box-shadow: 0 0 0 3px rgba(45, 82, 196, 0.25);
}

.dcp-color-row { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; }
.dcp-modal-body .form-control.dcp-color-picker {
  width: 56px;
  height: 40px;
  padding: 4px;
  border-radius: 10px;
  background-color: var(--dcp-field-bg);
  border: 1px solid var(--dcp-field-border);
}
.dcp-modal-body .form-control.dcp-hex-input { max-width: 160px; font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace; }
.dcp-swatches { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }
.dcp-swatches .dc-swatch-btn { width: 28px; height: 28px; border-radius: 9px; }

.dcp-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(148, 163, 184, 0.14);
}
.dcp-preview-label { font-size: 12px; font-weight: 800; letter-spacing: 0.6px; text-transform: uppercase; color: var(--dcp-muted); }
.dcp-hint { margin-top: 6px; font-size: 12.5px; color: var(--dcp-muted); }

/* ---------- toast ---------- */
.dcp-toast {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 2000;
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: min(420px, calc(100vw - 32px));
  padding: 12px 14px 12px 16px;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.3);
  animation: dcp-toast-in 0.25s ease both;
}
.dcp-toast.success { background: #0a5f34; }
.dcp-toast.error { background: #a11616; }
.dcp-toast > svg { flex-shrink: 0; font-size: 20px; }
.dcp-toast > span { flex: 1 1; }
.dcp-toast button {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  font-size: 17px;
}
.dcp-toast button:hover { background: rgba(255, 255, 255, 0.3); }

/* ---------- responsive ---------- */
@media (max-width: 991.98px) {
  .dcp-layout { grid-template-columns: minmax(0, 1fr); }
  .dcp-nav-list { flex-direction: row; overflow-x: auto; padding-bottom: 2px; }
  .dcp-nav-item { width: auto; flex: 0 0 auto; min-width: 190px; }
}
@media (max-width: 575.98px) {
  .dcp-hero { padding: 20px; }
  .dcp-hero-title { font-size: 26px; }
  .dcp-panel { padding: 18px 16px 20px; }
  .dcp-panel-actions { width: 100%; }
  .dcp-panel-actions .btn { flex: 1 1; }
  .dcp-count { margin-left: 0; }
  .dcp-toast { right: 16px; bottom: 16px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dataCenterPage.css"],"names":[],"mappings":"AAAA;;;;;;;;;+EAS+E;;AAE/E;EACE,oBAAoB;EACpB,qCAAqC;EACrC,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;;EAEE,sCAAsC;EACtC,qCAAqC;EACrC,uBAAuB;EACvB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC,yEAAyE;AACzE;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,eAAe,EAAE;AAC1B;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,eAAe,EAAE;AAC1B;AACA,YAAY,sCAAsC,EAAE,8BAA8B,EAAE;;AAEpF;EACE,mCAAmC,0BAA0B,EAAE;EAC/D,oDAAoD,2BAA2B,EAAE;AACnF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,0EAA0E;EAC1E,+CAA+C;AACjD;AACA;EACE,0EAA0E;EAC1E,2CAA2C;AAC7C;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,YAAY,EAAE,WAAW;EACzB,+EAA+E;AACjF;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,UAAU,EAAE,cAAc;EAC1B,+EAA+E;AACjF;AACA,kCAAkC,kBAAkB,EAAE,UAAU,EAAE;;AAElE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;EACjC,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;AACA,gBAAgB,SAAS,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAEhF,kBAAkB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAC5D;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iCAAiC;AACnC;AACA,mBAAmB,gBAAgB,EAAE,iBAAiB,EAAE;;AAExD,iCAAiC;AACjC;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;AACA,YAAY,YAAY,EAAE;;AAE1B;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA,sCAAsC;AACtC,WAAW,aAAa,EAAE;AAC1B,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEjE;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,0DAA0D;AAC5D;AACA,4BAA4B,cAAc,EAAE;AAC5C,sBAAsB,kCAAkC,EAAE;AAC1D,kCAAkC,qCAAqC,EAAE;AACzE,8BAA8B,0CAA0C,EAAE,mBAAmB,EAAE;;AAE/F;EACE,4CAA4C;EAC5C,8EAA8E;AAChF;AACA;EACE,wEAAwE;EACxE,0EAA0E;AAC5E;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,kCAAkC;AACpC;AACA;;EAEE,wEAAwE;EACxE,4DAA4D;AAC9D;AACA,qCAAqC,uCAAuC,EAAE,cAAc,EAAE;AAC9F;EACE,iEAAiE;EACjE,cAAc;AAChB;;AAEA,gBAAgB,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACxF,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAEzE;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA,6BAA6B,qCAAqC,EAAE,cAAc,EAAE;AACpF,sCAAsC,uCAAuC,EAAE,cAAc,EAAE;AAC/F,kDAAkD,iEAAiE,EAAE,cAAc,EAAE;;AAErI,gCAAgC;AAChC,aAAa,uBAAuB,EAAE;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA,kBAAkB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACnF,oBAAoB,SAAO,EAAE,gBAAgB,EAAE;AAC/C,mBAAmB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACzF,iBAAiB,eAAe,EAAE,iBAAiB,EAAE,uBAAuB,EAAE;AAC9E,qBAAqB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;;AAE/D,kCAAkC;AAClC;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,8EAA8E;AAChF;AACA,oCAAoC,2BAA2B,EAAE;AACjE,6BAA6B,0CAA0C,EAAE,mBAAmB,EAAE;AAC9F,sBAAsB,iBAAiB,EAAE,eAAe,EAAE;;AAE1D;EACE,cAAc;EACd,qDAAqD;EACrD,8CAA8C;AAChD;AACA;;EAEE,qDAAqD;EACrD,yCAAyC;AAC3C;AACA,oDAAoD,cAAc,EAAE;;AAEpE;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,sCAAsC;AACxC;AACA,oDAAoD,cAAc,EAAE,mBAAmB,EAAE;AACzF,gEAAgE,cAAc,EAAE,oCAAoC,EAAE;;AAEtH,6BAA6B,cAAc,EAAE,mBAAmB,EAAE;AAClE,6CAA6C,cAAc,EAAE,mBAAmB,EAAE;AAClF,kDAAkD,cAAc,EAAE,mBAAmB,EAAE;AACvF,kEAAkE,cAAc,EAAE,mBAAmB,EAAE;;AAEvG,8BAA8B,cAAc,EAAE,mBAAmB,EAAE;AACnE,mDAAmD,cAAc,EAAE,mBAAmB,EAAE;;AAExF,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,0DAA0D;AAC5D;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,kDAAkD,aAAa,EAAE;AACjE;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;AACA,0BAA0B,qCAAqC,EAAE;;AAEjE;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;EAC5C,kCAAkC;AACpC;AACA;EACE,wEAAwE;EACxE,4DAA4D;AAC9D;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,gCAAgC,qBAAqB,EAAE;AACvD,aAAa,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE;AACtE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;AAC1C;AACA,oCAAoC,gBAAgB,EAAE;AACtD,sBAAsB,iCAAiC,EAAE;AACzD,4BAA4B,mCAAmC,EAAE;AACjE,wCAAwC,qCAAqC,EAAE;;AAE/E,cAAc,WAAW,EAAE;AAC3B,iBAAiB,YAAY,EAAE;AAC/B,gBAAgB,YAAY,EAAE;AAC9B,mBAAmB,YAAY,EAAE,6BAA6B,EAAE;AAChE,+BAA+B,uBAAuB,EAAE,mBAAmB,EAAE;AAC7E,iBAAiB,gBAAgB,EAAE,uBAAuB,EAAE;AAC5D,YAAY,gBAAgB,EAAE;AAC9B,6BAA6B,gBAAgB,EAAE;AAC/C,iBAAiB,gBAAgB,EAAE;;AAEnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,aAAa,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAClE;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,wCAAwC;AAC1C;AACA,6BAA6B,uCAAuC,EAAE;;AAEtE,mBAAmB,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AACrE;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,4EAA4E;AAC9E;AACA,4BAA4B,cAAc,EAAE;AAC5C,sBAAsB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAClF,kCAAkC,qCAAqC,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAChH,6BAA6B,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACzF,yCAAyC,qCAAqC,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACvH,8BAA8B,0CAA0C,EAAE,mBAAmB,EAAE;;AAE/F,mDAAmD;AACnD,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACnE;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,mHAAmH;EACnH,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,kCAAkC;AACpC;AACA;EACE,wEAAwE;EACxE,4DAA4D;AAC9D;AACA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE;AACtD,iBAAiB,kBAAkB,EAAE,eAAe,EAAE,uBAAuB,EAAE;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qCAAqC;AACvC;AACA,oBAAoB,gBAAgB,EAAE,kBAAkB,EAAE;AAC1D,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,+BAA+B,qCAAqC,EAAE,cAAc,EAAE;;AAEtF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;oCACoC,qCAAqC,EAAE,cAAc,EAAE;;AAE3F,kCAAkC;AAClC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA,sBAAsB,mBAAmB,EAAE,oCAAoC,EAAE;AACjF;EACE,wDAAwD;EACxD,sCAAsC;AACxC;AACA;EACE,wDAAwD;EACxD,qCAAqC;AACvC;;AAEA,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,SAAS,EAAE;AACnF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA,0CAA0C,mBAAmB,EAAE;AAC/D,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,sDAAsD,mBAAmB,EAAE,cAAc,EAAE;;AAE3F,oBAAoB,cAAc,EAAE,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AAC9G,qBAAqB,eAAe,EAAE,gBAAgB,EAAE;;AAExD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;AACA,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;;AAEpE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;AACA,2BAA2B,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE;AAC7F,+CAA+C,cAAc,EAAE;AAC/D,uCAAuC,cAAc,EAAE;AACvD,2DAA2D,cAAc,EAAE;;AAE3E,iCAAiC;AACjC;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,kBAAkB,oCAAoC,EAAE;AACxD,kBAAkB,iCAAiC,EAAE,QAAQ,EAAE;AAC/D;kCACkC,uCAAuC,EAAE;AAC3E,6BAA6B,kDAAkD,EAAE;AACjF,mBAAmB,eAAe,EAAE,gBAAgB,EAAE;AACtD,8BAA8B,iBAAiB,EAAE,gBAAgB,EAAE;;AAEnE;EACE,mBAAmB;EACnB,yCAAyC;EACzC,qCAAqC;EACrC,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,SAAS,EAAE;AACjF;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,yCAAyC;AAC3C;AACA,8CAA8C,gBAAgB,EAAE,qEAAqE,EAAE;AACvI,gBAAgB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC5E,+BAA+B,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;AACA,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE,uBAAuB,EAAE;AACnI,YAAY,eAAe,EAAE,iBAAiB,EAAE,uBAAuB,EAAE;;AAEzE,gCAAgC;AAChC;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;EAC1C,uCAAuC;AACzC;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,mBAAmB,mBAAmB,EAAE;AACxC,mBAAmB,cAAc,EAAE,eAAe,EAAE;AACpD,oBAAoB,SAAO,EAAE;AAC7B;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;AACA,0BAA0B,oCAAoC,EAAE;;AAEhE,qCAAqC;AACrC;EACE,cAAc,qCAAqC,EAAE;EACrD,gBAAgB,mBAAmB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;EAC5E,gBAAgB,WAAW,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACjE;AACA;EACE,YAAY,aAAa,EAAE;EAC3B,kBAAkB,eAAe,EAAE;EACnC,aAAa,uBAAuB,EAAE;EACtC,qBAAqB,WAAW,EAAE;EAClC,0BAA0B,SAAO,EAAE;EACnC,aAAa,cAAc,EAAE;EAC7B,aAAa,WAAW,EAAE,YAAY,EAAE;AAC1C","sourcesContent":["/* ==========================================================================\n   Data Center page styling (scoped with the dcp- prefix).\n   Same visual language as Insights / Dashboard / Enquiries: gradient hero,\n   rounded cards, accent-tinted icon tiles. Accent colors come from the app-wide\n   tokens (.accent-blue/violet/teal/green in App.css), so every tinted element\n   works in both themes from one definition. All text keeps a 6:1 contrast\n   ratio and is never smaller than 12px.\n   The modals render outside the page container, so they carry their own\n   .dcp-modal-dark class instead of relying on .dark-theme.\n   ========================================================================== */\n\n:root {\n  --dcp-muted: #475569;\n  --dcp-line: rgba(148, 163, 184, 0.32);\n  --dcp-field-bg: #ffffff;\n  --dcp-field-border: #8a97a8;\n  --dcp-field-text: #111827;\n}\n.dark-theme.dcp-page,\n.dcp-modal-dark {\n  --dcp-muted: rgba(255, 255, 255, 0.72);\n  --dcp-line: rgba(255, 255, 255, 0.13);\n  --dcp-field-bg: #2a2f34;\n  --dcp-field-border: rgba(255, 255, 255, 0.28);\n  --dcp-field-text: #f1f5f9;\n}\n\n/* ---------- motion ---------- */\n/* slide only: fading text in makes it momentarily fail contrast checks */\n@keyframes dcp-fade-up {\n  from { transform: translateY(10px); }\n  to   { transform: none; }\n}\n@keyframes dcp-shimmer {\n  0%   { background-position: 100% 0; }\n  100% { background-position: 0 0; }\n}\n@keyframes dcp-toast-in {\n  from { transform: translateY(14px); }\n  to   { transform: none; }\n}\n.dcp-fade { animation: dcp-fade-up 0.45s ease both; animation-delay: var(--d, 0ms); }\n\n@media (prefers-reduced-motion: reduce) {\n  .dcp-fade, .dcp-skel, .dcp-toast { animation: none !important; }\n  .dcp-card, .dcp-nav-item, .dcp-icon-btn, .dcp-btn { transition: none !important; }\n}\n\n/* ---------- hero ---------- */\n.dcp-hero {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin: 8px 0 20px;\n  padding: 26px 30px;\n  border-radius: 22px;\n  color: #fff;\n  background: linear-gradient(120deg, #1a3483 0%, #2d52c4 55%, #6d3fae 100%);\n  box-shadow: 0 18px 40px rgba(26, 52, 131, 0.28);\n}\n.dark-theme .dcp-hero {\n  background: linear-gradient(120deg, #13224f 0%, #1f3a8a 55%, #4c2a85 100%);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);\n}\n.dcp-hero::before,\n.dcp-hero::after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  pointer-events: none;\n}\n.dcp-hero::before {\n  width: 260px; height: 260px;\n  right: -60px; top: -110px;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.22), transparent 70%);\n}\n.dcp-hero::after {\n  width: 200px; height: 200px;\n  right: 22%; bottom: -120px;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.14), transparent 70%);\n}\n.dcp-hero-text, .dcp-hero-stats { position: relative; z-index: 1; }\n\n.dcp-hero-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  background: rgba(6, 14, 40, 0.34);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n}\n.dcp-hero-title {\n  margin: 10px 0 4px;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -0.4px;\n  color: #fff;\n}\n.dcp-hero-sub { margin: 0; max-width: 620px; color: #ffffff; font-size: 14.5px; }\n\n.dcp-hero-stats { display: flex; flex-wrap: wrap; gap: 8px; }\n.dcp-hero-stat {\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  background: rgba(6, 14, 40, 0.38);\n}\n.dcp-hero-stat b { font-weight: 850; margin-right: 3px; }\n\n/* ---------- layout ---------- */\n.dcp-layout {\n  display: grid;\n  grid-template-columns: 300px minmax(0, 1fr);\n  gap: 18px;\n  align-items: start;\n}\n.dcp-main { min-width: 0; }\n\n.dcp-card {\n  border: 1px solid transparent;\n  border-radius: 18px;\n  background: #ffffff;\n  color: #111827;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07);\n}\n.dark-theme .dcp-card {\n  background: #212529;\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.1);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);\n}\n\n/* ---------- section nav ---------- */\n.dcp-nav { padding: 10px; }\n.dcp-nav-list { display: flex; flex-direction: column; gap: 4px; }\n\n.dcp-nav-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 11px 12px;\n  border: 1px solid transparent;\n  border-radius: 14px;\n  background: transparent;\n  text-align: left;\n  color: #111827;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.dark-theme .dcp-nav-item { color: #ffffff; }\n.dcp-nav-item:hover { background: rgba(15, 23, 42, 0.05); }\n.dark-theme .dcp-nav-item:hover { background: rgba(255, 255, 255, 0.07); }\n.dcp-nav-item:focus-visible { outline: 3px solid rgba(45, 82, 196, 0.45); outline-offset: 2px; }\n\n.dcp-nav-item.active {\n  background: var(--tmis-accent-tint, #eef2ff);\n  border-color: color-mix(in srgb, var(--tmis-accent, #1a3483) 35%, transparent);\n}\n.dark-theme .dcp-nav-item.active {\n  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);\n  border-color: color-mix(in srgb, var(--tmis-accent-dark) 45%, transparent);\n}\n\n.dcp-nav-icon,\n.dcp-panel-icon {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 12px;\n  font-size: 19px;\n  background: var(--tmis-accent-tint, #eef2ff);\n  color: var(--tmis-accent, #1a3483);\n}\n.dark-theme .dcp-nav-icon,\n.dark-theme .dcp-panel-icon {\n  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);\n  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n}\n.dcp-nav-item.active .dcp-nav-icon { background: var(--tmis-accent, #1a3483); color: #ffffff; }\n.dark-theme .dcp-nav-item.active .dcp-nav-icon {\n  background: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n  color: #0b1220;\n}\n\n.dcp-nav-text { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }\n.dcp-nav-label { font-size: 14.5px; font-weight: 800; line-height: 1.25; }\n\n.dcp-nav-count {\n  min-width: 26px;\n  height: 24px;\n  padding: 0 8px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 800;\n  background: #e8ecf2;\n  color: #1e293b;\n}\n.dark-theme .dcp-nav-count { background: rgba(255, 255, 255, 0.12); color: #ffffff; }\n.dcp-nav-item.active .dcp-nav-count { background: var(--tmis-accent, #1a3483); color: #ffffff; }\n.dark-theme .dcp-nav-item.active .dcp-nav-count { background: var(--tmis-accent-dark-text, var(--tmis-accent-dark)); color: #0b1220; }\n\n/* ---------- panel ---------- */\n.dcp-panel { padding: 22px 24px 24px; }\n.dcp-panel-head {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n.dcp-panel-icon { width: 46px; height: 46px; font-size: 23px; border-radius: 14px; }\n.dcp-panel-titles { flex: 1; min-width: 220px; }\n.dcp-panel-title { margin: 0; font-size: 21px; font-weight: 800; letter-spacing: -0.2px; }\n.dcp-panel-sub { margin: 2px 0 0; font-size: 13.5px; color: var(--dcp-muted); }\n.dcp-panel-actions { display: flex; flex-wrap: wrap; gap: 8px; }\n\n/* ---------- buttons ---------- */\n.dcp-page .dcp-btn.btn,\n.dcp-modal-dark .dcp-btn.btn,\n.modal .dcp-btn.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  padding: 9px 18px;\n  font-size: 14px;\n  font-weight: 700;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n.dcp-btn.btn:hover:not(:disabled) { transform: translateY(-1px); }\n.dcp-btn.btn:focus-visible { outline: 3px solid rgba(45, 82, 196, 0.45); outline-offset: 2px; }\n.dcp-btn.dcp-btn-sm { padding: 6px 14px; font-size: 13px; }\n\n.dcp-btn.dcp-btn-primary.btn {\n  color: #ffffff;\n  background: linear-gradient(120deg, #1a3483, #2457b8);\n  box-shadow: 0 8px 18px rgba(26, 52, 131, 0.28);\n}\n.dark-theme .dcp-btn.dcp-btn-primary.btn,\n.dcp-modal-dark .dcp-btn.dcp-btn-primary.btn {\n  background: linear-gradient(120deg, #2457b8, #5a43d0);\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.4);\n}\n.dcp-btn.dcp-btn-primary.btn:hover:not(:disabled) { color: #ffffff; }\n\n.dcp-btn.dcp-btn-outline.btn {\n  color: #1e293b;\n  background: #ffffff;\n  border-color: #8a97a8;\n}\n.dark-theme .dcp-btn.dcp-btn-outline.btn {\n  color: #f1f5f9;\n  background: transparent;\n  border-color: rgba(255, 255, 255, 0.4);\n}\n.dcp-btn.dcp-btn-outline.btn:hover:not(:disabled) { color: #0f172a; background: #eef2f7; }\n.dark-theme .dcp-btn.dcp-btn-outline.btn:hover:not(:disabled) { color: #ffffff; background: rgba(255, 255, 255, 0.1); }\n\n.dcp-btn.dcp-btn-ghost.btn { color: #1e293b; background: #e8ecf2; }\n.dcp-modal-dark .dcp-btn.dcp-btn-ghost.btn { color: #f1f5f9; background: #343a40; }\n.dcp-btn.dcp-btn-ghost.btn:hover:not(:disabled) { color: #0f172a; background: #d9dfe8; }\n.dcp-modal-dark .dcp-btn.dcp-btn-ghost.btn:hover:not(:disabled) { color: #ffffff; background: #444b52; }\n\n.dcp-btn.dcp-btn-danger.btn { color: #ffffff; background: #b02a37; }\n.dcp-btn.dcp-btn-danger.btn:hover:not(:disabled) { color: #ffffff; background: #8a1f2b; }\n\n/* ---------- toolbar / search ---------- */\n.dcp-toolbar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin: 20px 0 14px;\n}\n.dcp-search {\n  position: relative;\n  flex: 1 1 280px;\n  max-width: 440px;\n}\n.dcp-search-icon {\n  position: absolute;\n  left: 13px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 19px;\n  color: var(--dcp-muted);\n  pointer-events: none;\n}\n.dcp-search-input {\n  width: 100%;\n  height: 42px;\n  padding: 0 38px 0 40px;\n  font-size: 14px;\n  border-radius: 999px;\n  border: 1px solid var(--dcp-field-border);\n  background: var(--dcp-field-bg);\n  color: var(--dcp-field-text);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.dcp-search-input:focus {\n  outline: 0;\n  border-color: #2457b8;\n  box-shadow: 0 0 0 3px rgba(45, 82, 196, 0.25);\n}\n.dcp-search-input::-webkit-search-cancel-button { display: none; }\n.dcp-search-clear {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 26px;\n  height: 26px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--dcp-muted);\n  font-size: 17px;\n}\n.dcp-search-clear:hover { background: rgba(148, 163, 184, 0.25); }\n\n.dcp-count {\n  margin-left: auto;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 12.5px;\n  font-weight: 700;\n  background: var(--tmis-accent-tint, #eef2ff);\n  color: var(--tmis-accent, #1a3483);\n}\n.dark-theme .dcp-count {\n  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);\n  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n}\n\n/* ---------- table ---------- */\n.dcp-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--dcp-line);\n  border-radius: 14px;\n  transition: filter 0.2s ease;\n}\n.dcp-table-wrap.is-refreshing { filter: saturate(0.6); }\n.dcp-table { width: 100%; border-collapse: collapse; font-size: 14px; }\n.dcp-table th {\n  padding: 11px 14px;\n  text-align: left;\n  white-space: nowrap;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: var(--dcp-muted);\n  background: rgba(148, 163, 184, 0.14);\n  border-bottom: 1px solid var(--dcp-line);\n}\n.dcp-table td {\n  padding: 12px 14px;\n  vertical-align: middle;\n  border-bottom: 1px solid var(--dcp-line);\n}\n.dcp-table tbody tr:last-child td { border-bottom: 0; }\n.dcp-table tbody tr { transition: background 0.12s ease; }\n.dcp-table tbody tr:hover { background: rgba(26, 52, 131, 0.05); }\n.dark-theme .dcp-table tbody tr:hover { background: rgba(255, 255, 255, 0.05); }\n\n.dcp-col-no { width: 64px; }\n.dcp-col-color { width: 170px; }\n.dcp-col-date { width: 130px; }\n.dcp-col-actions { width: 120px; text-align: center !important; }\n.dcp-cell-no, .dcp-cell-date { color: var(--dcp-muted); white-space: nowrap; }\n.dcp-cell-desc { max-width: 380px; overflow-wrap: anywhere; }\n.dcp-name { font-weight: 800; }\n.dcp-table td:nth-child(2) { min-width: 150px; }\n.dcp-cell-desc { min-width: 180px; }\n\n.dcp-pill {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 800;\n  line-height: 1.4;\n  overflow-wrap: break-word;\n}\n\n.dcp-color { display: inline-flex; align-items: center; gap: 8px; }\n.dcp-color code {\n  padding: 0;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: inherit;\n  background: none;\n}\n.dcp-color-dot {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  border: 1px solid rgba(15, 23, 42, 0.25);\n}\n.dark-theme .dcp-color-dot { border-color: rgba(255, 255, 255, 0.35); }\n\n.dcp-row-actions { display: flex; justify-content: center; gap: 6px; }\n.dcp-icon-btn {\n  width: 34px;\n  height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  border: 1px solid var(--dcp-line);\n  background: transparent;\n  color: #1e293b;\n  font-size: 18px;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n.dark-theme .dcp-icon-btn { color: #f1f5f9; }\n.dcp-icon-btn:hover { background: #e6ebf8; color: #1a3483; border-color: #8aa0dd; }\n.dark-theme .dcp-icon-btn:hover { background: rgba(157, 195, 244, 0.16); color: #cfe2fb; border-color: #9dc3f4; }\n.dcp-icon-btn.danger:hover { background: #fee2e2; color: #a11616; border-color: #e58f8f; }\n.dark-theme .dcp-icon-btn.danger:hover { background: rgba(248, 113, 113, 0.16); color: #fcc4c4; border-color: #f87171; }\n.dcp-icon-btn:focus-visible { outline: 3px solid rgba(45, 82, 196, 0.45); outline-offset: 2px; }\n\n/* ---------- loading / empty / states ---------- */\n.dcp-skeletons { display: flex; flex-direction: column; gap: 10px; }\n.dcp-skel {\n  display: block;\n  height: 48px;\n  border-radius: 12px;\n  background: linear-gradient(90deg, rgba(148, 163, 184, 0.16), rgba(148, 163, 184, 0.34), rgba(148, 163, 184, 0.16));\n  background-size: 200% 100%;\n  animation: dcp-shimmer 1.3s ease infinite;\n}\n\n.dcp-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 42px 16px;\n  text-align: center;\n  border: 1px dashed var(--dcp-line);\n  border-radius: 14px;\n}\n.dcp-empty-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  margin-bottom: 4px;\n  border-radius: 18px;\n  font-size: 28px;\n  background: var(--tmis-accent-tint, #eef2ff);\n  color: var(--tmis-accent, #1a3483);\n}\n.dark-theme .dcp-empty-icon {\n  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);\n  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n}\n.dcp-empty-title { font-size: 16px; font-weight: 800; }\n.dcp-empty-sub { margin-bottom: 8px; font-size: 14px; color: var(--dcp-muted); }\n\n.dcp-state {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 20px;\n  padding: 16px 18px;\n  border-radius: 14px;\n  font-size: 14px;\n  background: rgba(148, 163, 184, 0.14);\n}\n.dcp-state-inline { margin-top: 12px; padding: 10px 14px; }\n.dcp-state-error { background: #fee2e2; color: #7f1212; }\n.dark-theme .dcp-state-error { background: rgba(248, 113, 113, 0.14); color: #fcc4c4; }\n\n.dcp-inline-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  background: #fee2e2;\n  color: #7f1212;\n}\n.dark-theme .dcp-inline-error,\n.dcp-modal-dark .dcp-inline-error { background: rgba(248, 113, 113, 0.14); color: #fcc4c4; }\n\n/* ---------- privacy ---------- */\n.dcp-privacy {\n  margin-top: 22px;\n  padding: 20px 22px;\n  border-radius: 16px;\n  background: #e2f6ea;\n  border: 1px solid rgba(10, 95, 52, 0.28);\n}\n.dcp-privacy.is-off { background: #fef3c7; border-color: rgba(130, 63, 9, 0.35); }\n.dark-theme .dcp-privacy {\n  background: color-mix(in srgb, #4ade80 10%, transparent);\n  border-color: rgba(94, 227, 143, 0.35);\n}\n.dark-theme .dcp-privacy.is-off {\n  background: color-mix(in srgb, #fbbf24 10%, transparent);\n  border-color: rgba(251, 191, 36, 0.4);\n}\n\n.dcp-privacy-top { display: flex; align-items: center; flex-wrap: wrap; gap: 14px; }\n.dcp-privacy-shield {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 14px;\n  font-size: 25px;\n  background: #0a5f34;\n  color: #ffffff;\n}\n.dcp-privacy.is-off .dcp-privacy-shield { background: #823f09; }\n.dark-theme .dcp-privacy-shield { background: #4ade80; color: #06210f; }\n.dark-theme .dcp-privacy.is-off .dcp-privacy-shield { background: #fbbf24; color: #2b1700; }\n\n.dcp-privacy-text { flex: 0 1 auto; display: flex; flex-direction: column; align-items: flex-start; gap: 4px; }\n.dcp-privacy-title { font-size: 18px; font-weight: 800; }\n\n.dcp-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12.5px;\n  font-weight: 800;\n}\n.dcp-status.ok { background: #0a5f34; color: #ffffff; }\n.dcp-status.warn { background: #823f09; color: #ffffff; }\n.dark-theme .dcp-status.ok { background: #4ade80; color: #06210f; }\n.dark-theme .dcp-status.warn { background: #fbbf24; color: #2b1700; }\n\n.dcp-privacy-list {\n  list-style: none;\n  margin: 18px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.dcp-privacy-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 14.5px;\n  line-height: 1.5;\n}\n.dcp-privacy-list li svg { flex-shrink: 0; margin-top: 3px; font-size: 18px; color: #0a5f34; }\n.dcp-privacy.is-off .dcp-privacy-list li svg { color: #823f09; }\n.dark-theme .dcp-privacy-list li svg { color: #5ee38f; }\n.dark-theme .dcp-privacy.is-off .dcp-privacy-list li svg { color: #fbc53d; }\n\n/* ---------- modals ---------- */\n.dcp-modal-dark .modal-content {\n  background: #212529;\n  color: #f1f5f9;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n.modal .modal-content { border-radius: 18px; }\n.dcp-modal-head { border-bottom-color: var(--dcp-line); }\n.dcp-modal-foot { border-top-color: var(--dcp-line); gap: 8px; }\n.dcp-modal-dark .dcp-modal-head,\n.dcp-modal-dark .dcp-modal-foot { border-color: rgba(255, 255, 255, 0.13); }\n.dcp-modal-dark .btn-close { filter: invert(1) grayscale(100%) brightness(200%); }\n.dcp-modal-title { font-size: 19px; font-weight: 800; }\n.dcp-modal-body .form-label { font-size: 13.5px; font-weight: 700; }\n\n.dcp-modal-body .form-control.dcp-input {\n  border-radius: 12px;\n  border: 1px solid var(--dcp-field-border);\n  background-color: var(--dcp-field-bg);\n  color: var(--dcp-field-text);\n}\n.dcp-modal-body .form-control.dcp-input:focus {\n  border-color: #2457b8;\n  box-shadow: 0 0 0 3px rgba(45, 82, 196, 0.25);\n}\n\n.dcp-color-row { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; }\n.dcp-modal-body .form-control.dcp-color-picker {\n  width: 56px;\n  height: 40px;\n  padding: 4px;\n  border-radius: 10px;\n  background-color: var(--dcp-field-bg);\n  border: 1px solid var(--dcp-field-border);\n}\n.dcp-modal-body .form-control.dcp-hex-input { max-width: 160px; font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace; }\n.dcp-swatches { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }\n.dcp-swatches .dc-swatch-btn { width: 28px; height: 28px; border-radius: 9px; }\n\n.dcp-preview {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 14px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(148, 163, 184, 0.14);\n}\n.dcp-preview-label { font-size: 12px; font-weight: 800; letter-spacing: 0.6px; text-transform: uppercase; color: var(--dcp-muted); }\n.dcp-hint { margin-top: 6px; font-size: 12.5px; color: var(--dcp-muted); }\n\n/* ---------- toast ---------- */\n.dcp-toast {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  max-width: min(420px, calc(100vw - 32px));\n  padding: 12px 14px 12px 16px;\n  border-radius: 14px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.3);\n  animation: dcp-toast-in 0.25s ease both;\n}\n.dcp-toast.success { background: #0a5f34; }\n.dcp-toast.error { background: #a11616; }\n.dcp-toast > svg { flex-shrink: 0; font-size: 20px; }\n.dcp-toast > span { flex: 1; }\n.dcp-toast button {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.18);\n  color: #ffffff;\n  font-size: 17px;\n}\n.dcp-toast button:hover { background: rgba(255, 255, 255, 0.3); }\n\n/* ---------- responsive ---------- */\n@media (max-width: 991.98px) {\n  .dcp-layout { grid-template-columns: minmax(0, 1fr); }\n  .dcp-nav-list { flex-direction: row; overflow-x: auto; padding-bottom: 2px; }\n  .dcp-nav-item { width: auto; flex: 0 0 auto; min-width: 190px; }\n}\n@media (max-width: 575.98px) {\n  .dcp-hero { padding: 20px; }\n  .dcp-hero-title { font-size: 26px; }\n  .dcp-panel { padding: 18px 16px 20px; }\n  .dcp-panel-actions { width: 100%; }\n  .dcp-panel-actions .btn { flex: 1; }\n  .dcp-count { margin-left: 0; }\n  .dcp-toast { right: 16px; bottom: 16px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
